// Theme management utility

export const THEME_STORAGE_KEY = 'hypseya-theme';

export const getTheme = () => {
  // FORCE LIGHT MODE ONLY - No dark mode in this version
  return 'light';
};

export const setTheme = (theme) => {
  // FORCE LIGHT MODE ONLY - Ignore any theme changes
  localStorage.setItem(THEME_STORAGE_KEY, 'light');
  document.documentElement.setAttribute('data-theme', 'light');
};

export const toggleTheme = () => {
  // FORCE LIGHT MODE ONLY - No toggling
  return 'light';
};

export const initTheme = () => {
  // FORCE LIGHT MODE ONLY
  document.documentElement.setAttribute('data-theme', 'light');
  localStorage.setItem(THEME_STORAGE_KEY, 'light');
  return 'light';
};

// Listen for system theme changes
export const watchSystemTheme = (callback) => {
  if (!window.matchMedia) return;
  
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  
  const handler = (e) => {
    // Only apply if user hasn't set explicit preference
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (!stored) {
      const theme = e.matches ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);
      callback && callback(theme);
    }
  };
  
  // Modern browsers
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }
  // Older browsers
  else if (mediaQuery.addListener) {
    mediaQuery.addListener(handler);
    return () => mediaQuery.removeListener(handler);
  }
};
